// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"c25a626d","2135":"c1e1b3f4"}[chunkId] + ".chunk.css";
};